import './Switch.style.sass';

/**
 * Figma design specification
 * https://www.figma.com/file/XKOJh2FJ678NacnAS2KqyA/UI%C2%A0components?node-id=2644%3A113974&t=KHyaMbJ8X3zQcwQF-0
 */

interface DunningSwitchProps {
  isChecked?: boolean;
  label?: string;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
  children?: React.ReactNode;
}

const Switch = ({ isChecked, onChange, children }: DunningSwitchProps) => {
  function onClick() {
    if (onChange) onChange(!isChecked);
  }

  return (
    <div className="dunning-switch-container" onClick={() => onClick()}>
      <div className={['switch', isChecked ? 'active' : null].join(' ')} />
      <span>{children}</span>
    </div>
  );
};

export { Switch };
